import { Faq } from '@boltenergy-be/design-system'
import Link from 'components/link/Link'
import { Trans, useTranslation } from 'next-i18next/pages'
import { routes } from 'utils/routes'
import { useGetLanguage } from 'hooks/useGetLanguage'
import { mapCmsFaqArticleToAccordionItem, mapFaqCategoryToFaqSection } from 'utils/cms'
import { FaqWithDefaultDescriptionProps } from './types'

const FaqWithDefaultDescription = ({ categories, ...props }: FaqWithDefaultDescriptionProps) => {
  // i18n
  const { t } = useTranslation()
  const language = useGetLanguage()

  return Array.isArray(categories) ? (
    <Faq
      description={
        <Trans t={t} i18nKey={($) => $.faq.description} components={[<Link key="0" variant="inline" href={routes(language).faq} />]} />
      }
      sections={categories.map((cat) => mapFaqCategoryToFaqSection(cat))}
      {...props}
    />
  ) : (
    <Faq
      description={
        <Trans t={t} i18nKey={($) => $.faq.description} components={[<Link key="0" variant="inline" href={routes(language).faq} />]} />
      }
      articles={categories.articles.map(mapCmsFaqArticleToAccordionItem)}
      {...props}
    />
  )
}

export default FaqWithDefaultDescription
